// react, react-redux, redux-form
import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

// helpers
import { required, number, greaterThanZero } from "../../../helpers/validate";
import {
  formatCurrency,
  normalizeCurrency,
  removeWorkCategory,
  jumpToError,
} from "../../../helpers/renderHelpers";
import { fileUploaded } from "../../../helpers/actionsHelpers";

// redux actions
import { saveAppState } from "../../../actions/appActions";

// enums
import { WORK_CATEGORY_LIST } from "../../../config/enums";

// render components
import RenderField from "../../global/RenderField";

const proposedWorks = (props) => {
  const {
    formData,
    formName,
    attachments,
    handleSubmit,
    previousPage,
    saveAppState,
    appState,
    isAppSaving,
  } = props;

  // Remove 'Subdivision/consolidation' from WORK_CATEGORY_LIST data list
  removeWorkCategory(WORK_CATEGORY_LIST, ["Subdivision/consolidation"]);

  let disabledTags;

  if (formData && formData.workCategories) {
    for (var i = 0; i < formData.workCategories.length; i++) {
      if (
        formData.workCategories[i].category === WORK_CATEGORY_LIST[0].category
      ) {
        disabledTags = WORK_CATEGORY_LIST[1];
      } else if (
        formData.workCategories[i].category === WORK_CATEGORY_LIST[1].category
      ) {
        disabledTags = WORK_CATEGORY_LIST[0];
      }
    }
  }

  return (
    <form id={formName} onSubmit={handleSubmit}>
      <div className="sq-form-section">
        <div className="sq-form-section-description">
          <h2>Proposed works</h2>
        </div>
        <Field
          name="workCategories"
          type="selectMultiple"
          component={RenderField}
          data={WORK_CATEGORY_LIST}
          disabledData={[disabledTags]}
          valueField="id"
          textField="category"
          label="Work Categories"
          placeholder="Add related work categories"
          validate={required}
          note="Please identify the category (or categories) your proposed works belong to."
          required
          busy
        />
        <Field
          name="detailedDescriptionOfProposedWorks"
          type="textarea"
          maxlength="1000"
          component={RenderField}
          label="Detailed description"
          note="Provide a detailed description of the proposed works."
          validate={required}
          required
        />
        <Field
          name="reasonAndPurposeOfProposedWorks"
          type="textarea"
          maxlength="1000"
          component={RenderField}
          label="Reason & purpose"
          note="State the reason and purpose for which the proposed works are required."
          validate={required}
          required
        />
        <Field
          name="impactOfProposedWorks"
          type="textarea"
          maxlength="1000"
          component={RenderField}
          label="Impact on heritage"
          note="State the impact of your proposed works and why the impact will not harm the heritage values of the place or object."
          validate={required}
          required
        />
        <Field
          name="estimatedCostOfWorks"
          type="text"
          component={RenderField}
          label="Estimated cost of the works ($)"
          note="The cost of works should be more than “$0”"
          validate={[required, number, greaterThanZero]}
          format={formatCurrency}
          normalize={normalizeCurrency}
          required
        />
      </div>
      <div className="sq-form-control">
        <button
          type="button"
          className="sq-form-page-button previous"
          onClick={previousPage}
        >
          Previous
        </button>
        <button
          type="submit"
          className="sq-form-page-button next"
          onClick={jumpToError}
        >
          Next
        </button>
      </div>
      <div className="sq-form-control">
        <button
          type="button"
          className="sq-form-page-button"
          onClick={() => saveAppState(appState, formName)}
          disabled={isAppSaving || fileUploaded(attachments)}
        >
          Save and Exit
        </button>
        <p className="sq-form-page-button-note">
          An email will be sent to Primary contact email address
        </p>
      </div>
    </form>
  );
};

const mapStateToProps = (state, formName) => {
  return {
    formData: state.form[formName.form] ? state.form[formName.form].values : {},
    attachments: state.service.attachments,
    isAppSaving: state.app.isAppSaving,
    appState: state,
  };
};

const mapDispatchToProps = {
  saveAppState,
};

const form = reduxForm({
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(form(proposedWorks));
